<template>
    <div>
        <div class="header-return">
            <el-row>
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="formInline.userGroupName" placeholder="输入名称查询"></el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="formInline.groupDesc" placeholder="输入描述查询"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList">查询</el-button>
                        <el-button type="success" @click="add()" class="header-btn">新建</el-button>
                        <el-button type="primary" @click="downLoad()" class="header-btn">下载导入模板</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="标识" prop="id" width="80"></el-table-column>
            <el-table-column label="组名称" prop="userGroupName" width="190"></el-table-column>
            <el-table-column label="描述" prop="groupDesc" width="230"></el-table-column>
            <el-table-column label="人数" prop="num" width="80"></el-table-column>
            <el-table-column label="状态" prop="statusName" width="70"></el-table-column>
            <el-table-column label="类型" prop="groupTypeName" width="150"></el-table-column>
            <el-table-column label="已推送次数" prop="sendNum" width="60"></el-table-column>
            <el-table-column label="更新时间" prop="updateTime" width="130">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.updateTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="danger" v-show="scope.row.groupType==2||scope.row.groupType==3" size="mini" @click="handleDel(scope.row)">删除</el-button>
                        <el-button type="primary" v-show="scope.row.groupType==2" @click="importData(scope.row)" size="mini" class="header-btn">导入</el-button>
                        <el-button type="primary" v-show="scope.row.groupType==3" @click="importTag(scope.row)" size="mini" class="header-btn">筛选用户</el-button>
                        <el-button type="danger" v-show="scope.row.num>=1&&(scope.row.groupType==2||scope.row.groupType==3)" size="mini" @click="handleDelUser(scope.row)">删除用户</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="用户组配置" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">
                <el-form-item label="组名称" prop="name">
                    <el-input v-model="model.userGroupName" placeholder="名称"></el-input>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="model.groupDesc" placeholder="描述"></el-input>
                </el-form-item>
                <el-form-item label="组类型">
                    <el-select v-model="model.groupType" :disabled="canEditGrouType"  clearable  placeholder="组类型">
                        <el-option v-for="item in groupTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">模板组由系统自动导入用户数据,用户上传组需要将用户整理到excel导入,用户标签组 需要根据标签筛选用户</span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="用户导入" :visible.sync="importShowDialog">
            <el-form label-width="120px">
                <el-form-item>
                    <el-upload
                            multiple
                            :with-credentials="true"
                            :show-file-list="false"
                            class="upload-demo"
                            :before-upload="beforeAvatarUpload"
                            :action="uploadUser"
                            :data="groupData"
                            :on-success="uploadSuccess"
                    >
                        <el-button size="small" type="primary">导入用户<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="用户标签导入" :visible.sync="labelShow">
            <el-row :gutter="20">
                <el-col :span="12"></el-col>
                <el-col :span="12"></el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getUserGroupListApi, saveGroupApi,uploadUserApi,downLoadUserApi,deleteGroupApi,deleteUserApi,updateGroupNumApi
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal:0,
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    userGroupName:'',
                    groupDesc:''
                },
                model: {
                    id:0,
                    userGroupName: '',
                    groupDesc: '',
                    groupType:2
                },
                loading: true,
                importShowDialog:false,
                labelShow:false,
                uploadUser:uploadUserApi,
                groupData:{groupId:9},
                canEditGrouType:false,
                groupTypeList:[{id:1,name:'模板组'},{id:2,name:'用户上传组'},{id:3,name:'标签组'}],
                beforeAvatarUpload(file) {
                    const isLt2M = file.size / 1024 / 1024 < 2;
                    let index = file.name.lastIndexOf(".");
                    let fileName = file.name.substr(index+1);
                    fileName==='xls'||fileName==='xlsx'||fileName==='cvs';
                    if (!fileName) {
                        this.$message.error('上传只能是excel 格式!');
                    }
                    if (!isLt2M) {
                        this.$message.error('上传大小不能超过 2MB!');
                    }
                    return fileName && isLt2M;
                },
                rules: {
                    name: [
                        {required: true, message: '应用名称必填', trigger: 'blur'}
                    ],
                    prefix: [
                        {required: true, message: '应用短信后缀必填', trigger: 'blur'}
                    ],
                    channelParams: [
                        {required: true, message: '第三方调用授权参数', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getUserGroupListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.model = {
                    userGroupName: '',
                    groupDesc: '',
                    groupType: 2
                };
                this.showDialog = true;
            },
            edit(row){
                this.model = {
                    id: row.id,
                    userGroupName: row.userGroupName,
                    groupDesc: row.groupDesc,
                    groupType:row.groupType
                };
                this.showDialog = true;
                if(row.groupType==1){
                    this.canEditGrouType=true;
                }else {
                    this.canEditGrouType=false;
                }
            },
            save(row){
                //保存应用
                if(this.model.userGroupName==''){
                    this.$message({
                        message: '组名称不能为空',
                        type: 'error'
                    });
                    return;
                }
                this.loading=true;
                saveGroupApi(this.model).then((res) => {
                    this.loading=false;
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteGroupApi({groupId:row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            handleDelUser(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteUserApi({groupId:row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            importData(row){
                this.model = {
                    id: row.id,
                    userGroupName: row.userGroupName,
                    groupDesc: row.groupDesc,
                    groupType:row.groupType
                };
                this.groupData.groupId=row.id;
                this.importShowDialog=true;
            },
            importTag(row){
                this.$router.push({
                    path:  '/groupRule',
                    query: {groupId:row.id,groupName:row.userGroupName}
                });
            },
            saveImportData(){
                uploadUserApi
            },
            downLoad(){
                let url = `${downLoadUserApi}?pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            uploadSuccess(res){
                this.importShowDialog=false;
                if(res.status==500){
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
                if(res.status==200){
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'success'
                    });
                    this.updateGroupNum();
                }
            },
            updateGroupNum(){
                updateGroupNumApi({groupId:this.model.id}).then((res) => {
                    console.log(res);
                    this.getList();
                });
            },
            formatDate(datetime) {
                if(datetime==null){
                    return '';
                }else {
                    var date = new Date(datetime);
                    var year = date.getFullYear(),
                        month = ("0" + (date.getMonth() + 1)).slice(-2),
                        sdate = ("0" + date.getDate()).slice(-2),
                        hour = ("0" + date.getHours()).slice(-2),
                        minute = ("0" + date.getMinutes()).slice(-2),
                        second = ("0" + date.getSeconds()).slice(-2);
                    // 拼接
                    var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
                    // 返回
                    return result;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/group.vue